// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "time-4PaHe";
var _4 = "flight-1-H3h";
var _5 = "selected-3XzJH";
var _6 = "segment__planeInfo-2aCYq";
var _7 = "segment__flightInfo-1EaYj";
var _8 = "segment__date-2hNc3";
var _9 = "airline-f7t6Y";
var _a = "timeInRoute-3eyJG";
var _b = "flightNumber-1mirc";
var _c = "segment__time-1EWhf";
var _d = "airport-eOkMa";
var _e = "aircraft-2CIPz";
var _f = "flightInfo__icon-2Cdq4";
var _10 = "stop__label-1RMAX";
var _11 = "flightPrice__button-2jk_F";
var _12 = "flightPrice__best-2BWpX";
var _13 = "flightPrice__price__money-1fmt8";
var _14 = "flightPrice__fare_family-IiOFM";
var _15 = "row-1qKqi";
var _16 = "route__info-1Gb09";
var _17 = "flightPrice__taxes-v1Av5";
var _18 = "date-7vDhI";
export { _1 as "__esModule", _2 as "mobile", _3 as "time", _4 as "flight", _5 as "selected", _6 as "segment__planeInfo", _7 as "segment__flightInfo", _8 as "segment__date", _9 as "airline", _a as "timeInRoute", _b as "flightNumber", _c as "segment__time", _d as "airport", _e as "aircraft", _f as "flightInfo__icon", _10 as "stop__label", _11 as "flightPrice__button", _12 as "flightPrice__best", _13 as "flightPrice__price__money", _14 as "flightPrice__fare_family", _15 as "row", _16 as "route__info", _17 as "flightPrice__taxes", _18 as "date" }
export default { "__esModule": _1, "mobile": _2, "time": _3, "flight": _4, "selected": _5, "segment__planeInfo": _6, "segment__flightInfo": _7, "segment__date": _8, "airline": _9, "timeInRoute": _a, "flightNumber": _b, "segment__time": _c, "airport": _d, "aircraft": _e, "flightInfo__icon": _f, "stop__label": _10, "flightPrice__button": _11, "flightPrice__best": _12, "flightPrice__price__money": _13, "flightPrice__fare_family": _14, "row": _15, "route__info": _16, "flightPrice__taxes": _17, "date": _18 }
